import { defineMessages } from 'react-intl';

const messages = defineMessages({
  shipmentCounter: {
    description: 'Label for the title representing the shipment details section',
    defaultMessage: 'Shipment {count} (of {total})',
    id: 'VlSjxU',
  },
  shipmentHeader: {
    description: 'Label for the shipment column in the edit amounts modal',
    defaultMessage: 'Shipment',
    id: 'Na/czl',
  },
  productCost: {
    description: 'Label for the cost of all products in the order',
    defaultMessage: 'Product',
    id: 'FH6jq1',
  },
  dutiesPaid: {
    description: 'Label for the duties paid by customer in the order',
    defaultMessage: 'Duties Paid',
    id: 'AD5rB+',
  },
  shippingCost: {
    description: 'Label for the shipping amount on the order',
    defaultMessage: 'Shipping',
    id: 'eDlROu',
  },
  taxAmount: {
    description: 'Label for the tax amount on the order',
    defaultMessage: 'Tax',
    id: 'X2seDS',
  },
  dutiesTotalAmount: {
    description: 'Label for the duties paid amount on the order',
    defaultMessage: 'Duties Paid',
    id: '/YNS1u',
  },
  dutiesTotalAmountTooltip: {
    description: 'Order details duties total tooltip',
    defaultMessage: 'Duties have been paid by the customer at checkout',
    id: 'jQeQ+R',
  },
  totalAmount: {
    description: 'Label for the total amount of the order',
    defaultMessage: 'Total',
    id: 'imvS+x',
  },
  totalPaid: {
    description: 'Label for the total amount paid on the order',
    defaultMessage: 'Total Paid',
    id: 'mld2Un',
  },
  saveButton: {
    description: 'save button for the edit amounts modal',
    defaultMessage: 'Save Changes',
    id: '+IXkyw',
  },
  shipmentLabel: {
    description: 'label for the shipment in the edit amounts modal',
    defaultMessage: 'Shipment {index}',
    id: 'DMDha/',
  },
  order: {
    description: 'label for the order in the edit amounts modal',
    defaultMessage: 'Order',
    id: 'CWsI6H',
  },
  editAmountsHeader: {
    description: 'header for the edit amounts modal',
    defaultMessage:
      'Edit the amounts for shipping, tax, and total paid for each shipment. The shipment amounts will add up to the order total.',
    id: 'GVBOfc',
  },
  editAmountsTitle: {
    description: 'title for the edit amounts modal',
    defaultMessage: 'Edit Shipment Amounts',
    id: '7u0flk',
  },
  errorBannerText: {
    defaultMessage: 'ShipStation could not save your changes. Please Cancel, then try to make your changes again. ',
    id: 'U6Z0/h',
    description: 'description of what went wrong when trying to save a piece of data from the shipment details section',
  },
  costSummary: {
    description: 'Cost Summary Title',
    defaultMessage: 'Cost Summary',
    id: '4DWQ9u',
  },
  editAmounts: {
    description: 'button that brings up the edit amounts modal',
    defaultMessage: 'Edit',
    id: 'uv0DXG',
  },
  totalPaidTooltip: {
    description: 'order details totalPaid tooltip',
    defaultMessage:
      'Total Paid as reported by the marketplace. This may include cost adjustments, such as discounts, taxes, shipping, etc.',
    id: '99+yVT',
  },
  totalTaxesInclusiveTooltip: {
    description: 'order details total with taxes tooltip',
    defaultMessage: 'Total is tax inclusive',
    id: 'Fh64Ss',
  },
});

export default messages;
